import React, { useState, useEffect } from 'react';
import { TextField, Box, Divider, IconButton } from '@mui/material';
import { SearchIcon, SortAscIcon, SortDescIcon } from 'components/SVG';
import CloseIcon from '@mui/icons-material/Close';

type Props = {
  onChange: (query: string) => void;
  currentIndex: string | number;
  totalMatches: string | number;
  onNextClick?: () => void;
  onPreviousClick?: () => void;
  onClose?: () => void;
  value?: string;
  showCancelButton?: boolean;
};

function SparkComponentSearchField({
  onChange,
  currentIndex,
  totalMatches,
  onPreviousClick,
  onNextClick,
  onClose,
  value = '',
  showCancelButton = true,
}: Props) {
  const [inputValue, setInputValue] = useState(value);

  useEffect(() => {
    setInputValue(value);
  }, [value]);

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = e.target.value;
    setInputValue(newValue);

    if (newValue.length >= 3 || newValue.length === 0) {
      onChange(newValue);
    }
  };

  return (
    <TextField
      value={inputValue}
      placeholder='Search'
      fullWidth={true}
      onChange={handleInputChange}
      InputProps={{
        startAdornment: (
          <Box paddingRight={1} marginTop={1}>
            <SearchIcon width='20' height='20' />
          </Box>
        ),
        endAdornment: (
          <>
            {totalMatches ? (
              <>
                <Box component='span' paddingX={1} sx={{ color: 'black' }}>
                  {currentIndex}/{totalMatches}
                </Box>
                <Box height='30px'>
                  <Divider orientation='vertical' />
                </Box>
                <IconButton onClick={onNextClick} sx={{ padding: '2px' }}>
                  <SortAscIcon />
                </IconButton>
                <IconButton onClick={onPreviousClick} sx={{ padding: '2px' }}>
                  <SortDescIcon />
                </IconButton>
              </>
            ) : null}
            {(showCancelButton || inputValue?.length > 2) && (
              <IconButton
                onClick={onClose}
                sx={{ padding: '2px', color: 'black' }}
              >
                <CloseIcon />
              </IconButton>
            )}
          </>
        ),
      }}
    />
  );
}

export default SparkComponentSearchField;
